import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    Employee,
    Opportunity,
    OpportunitySalesCycleMap,
    Product,
    QuoteOrderLine,
    QuoteOrderLineByOpportunity,
    QuoteOrderLineType,
    SalesCycle,
    SalesCycleCheckList,
    SalesCycleCheckListMap
} from '../../models/models';

@Component({
    selector: 'customer-opportunity-sales-cycle',
    templateUrl: './customer-opportunity-sales-cycle.component.html',
    standalone: false
})
export class CustomerOpportunitySalesCycle implements OnInit, OnChanges, AfterViewInit {
    @Input() opportunityID: number = 0;
    @Input() opportunitySalesCycleMapID: number = 0;
    //@Input() opportunitySalesCycleMap: OpportunitySalesCycleMap = {} as OpportunitySalesCycleMap;
    //@Output() onRefresh: EventEmitter<boolean> = new EventEmitter<boolean>();

    private editedLineRowIndex: number | undefined;
    private editedLine: QuoteOrderLine = {} as QuoteOrderLine;

    public isSaving: boolean = false;

    public selectedOpp: OpportunitySalesCycleMap = {} as OpportunitySalesCycleMap;
    public opportunity: Opportunity = {} as Opportunity;
    public allSalesCycles: SalesCycle[] = [];
    public salesCycles: SalesCycle[] = [];
    public endSalesCycles: SalesCycle[] = [];
    public salesCycleCheckLists: SalesCycleCheckList[] = [];
    public checkListMaps: SalesCycleCheckListMap[] = [];
    public currentChecklist: SalesCycleCheckList[] = [];
    public employees: Employee[] = [];
    public products: Product[] = [];
    public lines: QuoteOrderLineByOpportunity[] = [];
    public lineTypes: QuoteOrderLineType[] = [];
    public salesCycleGroup: UntypedFormGroup = new UntypedFormGroup({});
    public opportunityGroup: UntypedFormGroup = new UntypedFormGroup({});
    public lineView: GridDataResult = { data: [], total: 0 };
    public lineState: State = { skip: 0, take: 10 };
    public newSalesCycleId: number = -1;
    public phoneMask: string = "(999) 000-0000";
    public oppMessage: string = '';
    //public isRequiredLikelihoodOfWin: boolean = false;

    @ViewChild('stepper', { static: false }) stepper: MatStepper | undefined;

    constructor(private crmService: CRMService, private orderService: OrderService, private employeeService: EmployeeService,
        private utilService: UtilService) {
    }

    ngOnInit() {
        this.getSalesCycles();
        this.getSalesCycleCheckLists();
        this.getEmployees();
        this.getProducts();
    }

    ngOnChanges(changes: SimpleChanges) {
        //if (changes.opportunitySalesCycleMap == null
        //    || changes.opportunitySalesCycleMap.currentValue == null
        //    || (changes.opportunitySalesCycleMap.currentValue as OpportunitySalesCycleMap).opportunityId == null) return;

        //this.selectedOpp = changes.opportunitySalesCycleMap.currentValue as OpportunitySalesCycleMap;
        this.getOpportunity();
    }

    private getOpportunity() {
        this.crmService.getOpportunityById(this.opportunityID).subscribe(result => {
            this.opportunity = result;
            this.getOpportunitySalesCycleMap(true);
        });
    }

    private getOpportunitySalesCycleMap(isInit: boolean) {
        if (this.opportunitySalesCycleMapID > 0) {
            this.crmService.getOpportunitySalesCylceMapById(this.opportunitySalesCycleMapID).subscribe(result => {
                this.selectedOpp = result;
                if (isInit) {
                    this.loadCheckListMaps();
                    //this.setOpportunityValues();
                    this.getLineTypes();
                    this.getLinesForOpportunity();
                    this.alertUserForEstimatedRevenue();
                }
                //this.ngAfterViewInit();
                //this.checkLikelihoodOfWin();
                console.log("getOpportunitySalesCycleMap", this.selectedOpp);
            });
        }
    }

    ngAfterViewInit() {
        this.stepper!._steps.changes.subscribe(() => {
            // Sales Ccyles before End of Cycle
            var salesCycle = this.salesCycles.find(s => s.salesCycleId == this.selectedOpp.salesCycleId);
            // Sales Ccyles that are End of Cycle
            var endSalesCycle = this.endSalesCycles.find(s => s.salesCycleId == this.selectedOpp.salesCycleId);
            var stage = 0;
            //var sortDescriptor = { skip: 0, take: 200, sort: [{ dir: 'asc', field: 'stage' }] } as State;

            if (salesCycle != undefined) {
                stage = salesCycle.stage;
            }
            else if (endSalesCycle != undefined) {
                stage = this.stepper!.steps.length;
            }
            else {
                return;
            }

            for (var i = 0; i < stage; i++) {
                this.stepper!.next();
            }

            //console.log("ngAfterViewInit:_steps.changes", stage, this.selectedOpp, this.salesCycleCheckLists, this.currentChecklist);
        });

        this.stepper!.selectionChange.subscribe(indexChange => {
            //console.log("ngAfterViewInit:_steps.changes", this.salesCycleCheckLists);
            if (this.salesCycleCheckLists.length < 1) return;
            //console.log("ngAfterViewInit:selectionChange", stage, indexChange.selectedIndex, this.selectedOpp, this.salesCycleCheckLists, this.currentChecklist);
        });
        //console.log("ngAfterViewInit", this.selectedOpp, this.currentChecklist);
    }

    private getSalesCycles() {
        this.crmService.getSalesCycles().subscribe(result => {
            this.allSalesCycles = result;
            this.salesCycles = result.filter(t => t.endOfCycleInd != true);
            this.endSalesCycles = result.filter(t => t.endOfCycleInd == true);
            this.buildSalesCycleForm();
            this.setMapFormValues();
        });
    }

    private getSalesCycleCheckLists() {
        this.crmService.getSalesCycleCheckLists().subscribe(result => {
            this.salesCycleCheckLists = result;
            this.buildSalesCycleForm();
            this.setMapFormValues();
        });
    }

    private loadCheckListMaps() {
        this.crmService.getSalesCycleCheckListMapsByOpportunityId(this.selectedOpp.opportunityId).subscribe(result => {
            this.checkListMaps = result;
            this.setMapFormValues();
            //this.checkLikelihoodOfWin();
        });
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employees = result;
        });
    }

    private getProducts() {
        this.orderService.getProducts().subscribe(result => {
            this.products = result;
        });
    }

    public getLineTypes() {
        this.orderService.getQuoteOrderLineTypesByProductId(this.opportunity.productId).subscribe(result => {
            this.lineTypes = result;
        });
    }

    public getLinesForOpportunity() {
        this.orderService.getQuoteOrderLinesByOpportunityId(this.selectedOpp.opportunityId).subscribe(result => {
            this.lines = result;
            this.setLinesGrid();
        });
    }

    private buildSalesCycleForm() {
        if (this.allSalesCycles.length < 1 || this.salesCycleCheckLists.length < 1) return;

        for (let salesCycle of this.allSalesCycles) {
            var checkListGroup = new UntypedFormGroup({});
            var checkLists = this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycle.salesCycleId);

            for (let checkList of checkLists) {
                checkListGroup.addControl(checkList.stage.toString() + 'Checkbox', new UntypedFormControl('', Validators.required));
                checkListGroup.addControl(checkList.stage.toString() + 'Text', new UntypedFormControl(''));
            }

            this.salesCycleGroup.addControl(salesCycle.abbrev, checkListGroup);
        }
    }

    public getCheckListBySalesCycleId(salesCycleId: number): SalesCycleCheckList[] {
        var checkList = this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycleId);
        var sortDescriptor = { skip: 0, take: 200, sort: [{ dir: 'asc', field: 'stage' }] } as State;
        if (sortDescriptor.sort) {
            checkList = orderBy(checkList, sortDescriptor.sort);
        }
        return checkList;
    }

    private setMapFormValues() {
        if (this.checkListMaps.length < 1 || this.allSalesCycles.length < 1 || this.salesCycleCheckLists.length < 1) return;

        for (let salesCycle of this.allSalesCycles) {
            var salesGroup = this.salesCycleGroup.controls[salesCycle.abbrev] as UntypedFormGroup;
            var checkLists = this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycle.salesCycleId);

            for (let checkList of checkLists) {
                var listMap = this.checkListMaps.find(s => s.salesCycleCheckListId == checkList.salesCycleCheckListId);

                if (listMap != null) {
                    var checkBoxCtrl = salesGroup.controls[checkList.stage.toString() + 'Checkbox'];
                    var textCtrl = salesGroup.controls[checkList.stage.toString() + 'Text'];

                    checkBoxCtrl.setValue(listMap.completed);
                    textCtrl.setValue(listMap.notes);
                }
            }
        }
    }

    private setLinesGrid() {
        if (this.lineState.sort) {
            this.lines = orderBy(this.lines, this.lineState.sort);
        }

        this.lineView = process(this.lines, this.lineState);
    }

    public lineDataStateChange(state: DataStateChangeEvent) {
        this.lineState = state;
        this.setLinesGrid();
    }

    public lineEditHandler({ sender, rowIndex, dataItem }) {
        this.lineCloseEditor(sender);

        this.editedLineRowIndex = rowIndex;
        this.editedLine = Object.assign({}, dataItem);

        sender.editRow(rowIndex);
    }

    public lineCancelHandler({ sender, rowIndex }) {
        this.lineCloseEditor(sender, rowIndex);
    }

    private lineCloseEditor(grid, rowIndex = this.editedLineRowIndex) {
        grid.closeRow(rowIndex);
        this.resetLine(this.editedLine);
        this.editedLineRowIndex = undefined;
        this.editedLine = {} as QuoteOrderLine;
    }

    private resetLine(line: QuoteOrderLine) {
        if (!line) return;

        const originalLine = this.lines.find(l => l.quoteNumber == line.quoteOrderLineID)!;
        Object.assign(originalLine, line);
    }

    //public lineSaveHandler({ sender, rowIndex, dataItem, isNew }) {
    //    var newLineType = this.lineTypes.find(t => t.quoteOrderLineTypeId == dataItem.quoteOrderLineTypeID);

    //    if (newLineType == null) return;

    //    dataItem.lastModifiedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
    //    dataItem.quoteOrderLineType = newLineType;

    //    this.orderService.saveQuoteOrderLine(dataItem).subscribe(result => {            
    //        var wonSalesCycle = this.allSalesCycles.find(s => s.description == 'Won');
    //        var lostSalesCycle = this.allSalesCycles.find(s => s.description == 'Lost');

    //        if (wonSalesCycle != null && newLineType!.wonInd != null && newLineType!.wonInd == true && this.selectedOpp.salesCycleId != wonSalesCycle.salesCycleId) {
    //            this.newSalesCycleId = wonSalesCycle.salesCycleId;
    //            this.updateSalesCycle();
    //        }

    //        if (lostSalesCycle != null && newLineType!.lostInd != null && newLineType!.lostInd == true) {
    //            var lineCount = this.lines.length;
    //            var lostLineCount = this.lines.filter(l => l.lineTypeLostInd == true).length;

    //            if (lineCount == lostLineCount && this.selectedOpp.salesCycleId != lostSalesCycle.salesCycleId) {
    //                this.newSalesCycleId = lostSalesCycle.salesCycleId;
    //                this.updateSalesCycle();
    //            }
    //        }
    //    });

    //    sender.closeRow(rowIndex);
    //    this.editedLineRowIndex = undefined;
    //    this.editedLine = {} as QuoteOrderLine;
    //}

    public saveChecklistMap(checklist: SalesCycleCheckList) {
        console.log("saveChecklistMap:start", checklist);
        if (checklist == null) return;

        var salesGroup = this.salesCycleGroup.controls[checklist.salesCycle.abbrev] as UntypedFormGroup;

        if (!salesGroup) return;

        var checkboxCtrl = salesGroup.controls[checklist.stage.toString() + 'Checkbox'];

        if (!checkboxCtrl) return;

        var listMap = this.checkListMaps.find(s => s.salesCycleCheckListId == checklist.salesCycleCheckListId);
        var completed = salesGroup.controls[checklist.stage.toString() + 'Checkbox'].value as boolean;
        var notes = salesGroup.controls[checklist.stage.toString() + 'Text'].value.toString();

        if (!completed && notes.length < 1 && listMap != null) {
            this.crmService.deleteSalesCycleChecklistMap(listMap).subscribe(result => {
                this.loadCheckListMaps();
            });
        }

        if (!completed || notes.length < 1) return;

        if (listMap == null) {
            listMap = {
                salesCycleCheckListMapId: 0,
                salesCycleCheckListId: checklist.salesCycleCheckListId,
                salesCycleId: checklist.salesCycleId,
                opportunityId: this.selectedOpp.opportunityId,
                createdByEmployeeId: parseInt(localStorage.getItem('EmployeeId')!)
            } as SalesCycleCheckListMap;
        } else {
            listMap.lastModifiedByEmployeeId = parseInt(localStorage.getItem('EmployeeId')!);
        }

        if (listMap.notes == notes && listMap.completed == completed) return;

        listMap.completed = completed;
        listMap.notes = notes;

        console.log("saveChecklistMap:before save", listMap, completed, notes, checklist);

        this.crmService.saveSalesCycleCheckListMap(listMap).subscribe(result => {
            var thisListMap = this.checkListMaps.find(c => c.salesCycleCheckListMapId == result.salesCycleCheckListMapId);

            if (thisListMap == null) {
                this.checkListMaps.push(result);
            } else {
                thisListMap.createdByEmployeeId = result.createdByEmployeeId;
            }
            //this.checkLikelihoodOfWin();
            this.getOpportunitySalesCycleMap(false);
            console.log("saveChecklistMap:after save", listMap, thisListMap, checklist);
        });
    }

    public saveCheckLists(salesCycle: SalesCycle) {
        var salesGroup = this.salesCycleGroup.controls[salesCycle.abbrev] as UntypedFormGroup;
        var checkLists = this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycle.salesCycleId);

        for (let checkList of checkLists) {
            var listMap = this.checkListMaps.find(s => s.salesCycleCheckListId == checkList.salesCycleCheckListId);
            var completed = salesGroup.controls[checkList.stage.toString() + 'Checkbox'].value as boolean;
            var notes = salesGroup.controls[checkList.stage.toString() + 'Text'].value.toString();

            if (!completed || notes.length < 1) continue;

            if (listMap == null) {
                listMap = {
                    salesCycleCheckListMapId: 0,
                    salesCycleCheckListId: checkList.salesCycleCheckListId,
                    salesCycleId: salesCycle.salesCycleId,
                    opportunityId: this.selectedOpp.opportunityId,
                    createdByEmployeeId: parseInt(localStorage.getItem('EmployeeId')!)
                } as SalesCycleCheckListMap;
            } else {
                listMap.lastModifiedByEmployeeId = parseInt(localStorage.getItem('EmployeeId')!);
            }

            listMap.completed = completed;
            listMap.notes = notes;

            this.crmService.saveSalesCycleCheckListMap(listMap).subscribe(result => {
                var hmmm = result;
            });
        }
    }

    public getSalesCycle() {
        var salesCycle = this.allSalesCycles.find(t => t.salesCycleId == this.newSalesCycleId);
        this.selectedOpp.salesCycleId = this.newSalesCycleId;
        this.selectedOpp.salesCycle = salesCycle!;
    }

    public updateSalesCycle() {
        console.log("updateSalesCycle", this.newSalesCycleId);
        if (this.newSalesCycleId < 1 || this.utilService.isLoading) return;

        var salesCycle = this.allSalesCycles.find(s => s.salesCycleId == this.newSalesCycleId);

        if (salesCycle == null) return;
        if (this.selectedOpp.salesCycle.stage >= salesCycle.stage) return;

        this.utilService.isLoading = true;
        this.selectedOpp.salesCycleId = this.newSalesCycleId;
        this.selectedOpp.employeeId = parseInt(localStorage.getItem('EmployeeId')!);

        this.crmService.jumpOpportunitySalesCycle(this.selectedOpp).subscribe(result => {
            this.selectedOpp.salesCycle = salesCycle!;
            this.utilService.isLoading = false;
            this.loadCheckListMaps();

            for (var i = this.stepper!.selectedIndex; i < salesCycle!.stage; i++) {
                this.stepper!.next();
            }
            //this.checkLikelihoodOfWin();
        });
    }

    public getCompletedChecklistTimestamp(checklist: SalesCycleCheckList) {
        var listMap = this.checkListMaps.find(c => c.salesCycleCheckListId == checklist.salesCycleCheckListId);

        if (listMap == null || listMap.salesCycleCheckListMapId < 1 || !listMap.completed) return '';

        var completedDate = new Date(listMap.completedDate);
        var employee = this.employees.find(e => e.employeeId == listMap!.createdByEmployeeId);

        return ' | Completed ' +
            + (completedDate.getMonth() + 1) + '/' + completedDate.getDate() + '/' + completedDate.getFullYear()
            + ' by ' + (employee == null ? '' : employee.fullName);
    }

    public isChecklistComplete(salesCycle: SalesCycle): boolean {
        var isCompleted = true;

        var salesGroup = this.salesCycleGroup.controls[salesCycle.abbrev] as UntypedFormGroup;

        if (!salesGroup) return false;

        var checkLists = this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycle.salesCycleId);

        for (let checkList of checkLists) {
            var listMap = this.checkListMaps.find(s => s.salesCycleCheckListId == checkList.salesCycleCheckListId);
            var completed = salesGroup.controls[checkList.stage.toString() + 'Checkbox'].value as boolean;
            var notes = salesGroup.controls[checkList.stage.toString() + 'Text'].value.toString();

            if (!completed || notes.length < 1) {
                isCompleted = false;
            }
        }

        return isCompleted;
    }

    public saveOpportunity() {
        this.isSaving = true;
        this.crmService.saveOpportunity(this.opportunity).subscribe(result => {
            this.isSaving = false;
            console.log("saveOpportunity", this.opportunity, result);
            this.opportunity = result;
        });
    }

    private alertUserForEstimatedRevenue() {
        if (this.selectedOpp != null && this.selectedOpp.opportunityId != null && this.selectedOpp.salesCycle != null
            && (this.opportunity.estimatedRevenue == null || this.opportunity.estimatedRevenue < 1)
            && (this.selectedOpp.salesCycle.description == 'Won'
                || this.selectedOpp.salesCycle.description == 'Finalist(50-75% win)'
                || this.selectedOpp.salesCycle.description == 'Pre-Award (90%)')) {
            alert('Please enter an estimated revenue for the opportunity below.');
        }
    }
}
